import { API_DOMAIN } from "../../utils/GlobalConst";
import moment from "moment";
import axios from "axios";
import { toast } from "react-toastify";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import mainlogo from "../../assets/img/tiq8-Logo-white.png";
// import QRCode from "react-qr-code";
import QRCode from "qrcode"; // Import QR code generator
import dummyEve from "../../assets/img/event-imgs/big-1.jpg";
export async function generateAndSendPDF(newArray) {
  try {
    // 1️⃣ Create a new PDF Document
    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage([595, 900]); // A4 Portrait
    const { width, height } = page.getSize();
    const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

    // Colors
    const grey = rgb(0.9, 0.9, 0.9);
    const black = rgb(0, 0, 0);
    const blue = rgb(28 / 255, 33 / 255, 49 / 255);
    let y = height - 50; // Initial Y position

    // const font = 14;
    const eventData = JSON.parse(sessionStorage.getItem("EveDetail"));
    const SeatsDetails = JSON.parse(sessionStorage.getItem("SeatsDetails"));
    const SeatsDetailsStanding = JSON.parse(
      sessionStorage.getItem("SeatsDetailsStanding")
    );
    const selectedVirtualCategory = JSON.parse(
      sessionStorage.getItem("selectedVirtualCategory")
    );
    const selectedStandingCategory = JSON.parse(
      sessionStorage.getItem("selectedStandingCategory")
    );
    console.log("eventData", eventData, " SeatsDetails", SeatsDetails);
    //  Fetch Image (PNG or JPEG)
    const imageBytes = await fetch(mainlogo).then((res) => res.arrayBuffer());

    //  Embed Image (Supports PNG & JPG)
    const pngImage = await pdfDoc.embedPng(imageBytes); // Use `embedJpg(imageBytes)` for JPG
    // 2️⃣ Draw Invoice Header
    // Draw Header (Grey Box)
    page.drawRectangle({
      x: 0,
      y: height - 50,
      width,
      height: 80,
      color: rgb(0, 0, 0.2),
    });
    page.drawImage(pngImage, {
      x: 50,
      y,
      width: 100,
      height: 40,
      opacity: 1,
    });

   
    if (sessionStorage.getItem("CategoryType") === "standing") {
      //STANDING INVOICE
      // Draw Invoice Details
      y -= 80;
      page.drawText(
        `Invoice to: ${sessionStorage.getItem(
          "userfirstname"
        )} ${sessionStorage.getItem("userlastname")}`,
        {
          x: 50,
          y,
          size: 12,
          font,
        }
      );
      page.drawText(
        `Invoice ID: ${sessionStorage.getItem("paymentIDstanding")}`,
        {
          x: 300,
          y,
          size: 12,
          font,
        }
      );
      
      // Table Header
      y -= 40;
      page.drawRectangle({
        x: 50,
        y: y,
        width: 495,
        height: 25,
        color: grey,
      });

      page.drawText("#", { x: 60, y: y + 7, size: 12, font, color: black });
      page.drawText("Event Details", { x: 90, y: y + 7, size: 12, font });
      page.drawText("Type", { x: 250, y: y + 7, size: 12, font });
      page.drawText("Qty", { x: 340, y: y + 7, size: 12, font });
      page.drawText("Unit Price", { x: 390, y: y + 7, size: 12, font });
      page.drawText("Total", { x: 480, y: y + 7, size: 12, font });

      // Table Content
      y -= 30;
      page.drawText("1", { x: 60, y, size: 12, font });
      page.drawText(`${eventData[0]?.EventTitle}`, {
        x: 90,
        y,
        size: 12,
        font,
      });
      page.drawText(eventData[0]?.EventType, { x: 250, y, size: 12, font });
      page.drawText(SeatsDetailsStanding.length.toString(), {
        x: 340,
        y,
        size: 12,
        font,
      });
      page.drawText(
        `${eventData[0]?.sell_currency}  ${Number(
          selectedStandingCategory?.standing_price
        )
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        { x: 390, y, size: 12, font }
      );
      page.drawText(
        `${eventData[0]?.sell_currency} ${Number(
          selectedStandingCategory?.standing_price * SeatsDetailsStanding.length
        )
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        {
          x: 480,
          y,
          size: 12,
          font,
        }
      );

      // Invoice Total
      y -= 40;
      page.drawText(
        `Invoice Total: ${eventData[0]?.sell_currency} ${Number(
          selectedStandingCategory?.standing_price * SeatsDetailsStanding.length
        )
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        {
          x: 400,
          y,
          size: 14,
          font,
        }
      );
      // Draw Cut Line
      y -= 20;
      page.drawLine({
        start: { x: 50, y },
        end: { x: 545, y },
        thickness: 1,
        color: black,
      });
      // Ticket dimensions (adjust if needed)
      const ticketWidth = 500;
      const ticketHeight = 150;
      const greyBoxWidth = ticketWidth / 2; // Half the width
      const borderThickness = 1; // Thickness of the border

      const startX = 50; // Adjust as needed
      const startY = 350; // Adjust as needed
      // Map Over Tickets
      for (let i = 0; i < SeatsDetailsStanding.length; i++) {
        const ticket = SeatsDetailsStanding[i];
        console.log("ticket", ticket);
        y -= 120;
        // STEP 1: Draw the left grey section (only background)
        page.drawRectangle({
          x: 40,
          y: y-50,
          width: ticketWidth / 2, // Half of the ticket width
          height: ticketHeight,
          color: grey,
          opacity: 1, // Ensure solid background
        });

        // STEP 2: Draw the border LAST (so it doesn't overlap table)
        page.drawRectangle({
          x: 40,
          y: y-50,
          width: ticketWidth,
          height: ticketHeight,
          borderColor: black,
          borderWidth: borderThickness,
          color: undefined, // Ensures no extra background fill
        });

        // Event Image (if needed).
        if (eventData[0].EventImagePath !== "path") {
          page.drawImage(eventData[0].EventImagePath, {
            x: 60,
            y: y - 50,
            width: 50,
            height: 50,
          });
        } else {
          page.drawImage(pngImage, {
            x: 50,
            y: 20,
            width: 100,
            height: 50,
          });
        }

        // Event Details
        page.drawText(eventData[0].EventTitle, {
          x: 120,
          y: y + 40,
          size: 12,
          font,
        });
        page.drawText(
          `${moment(eventData[0].StartDate).format("DD MMM YYYY, hh:mm A")}`,
          { x: 120, y: y + 25, size: 10, font }
        );
        page.drawText(
          `Total: ${eventData[0]?.sell_currency} ${selectedStandingCategory?.standing_price}`,
          {
            x: 120,
            y: y + 10,
            size: 10,
            font,
          }
        );

        // Seat Details
        page.drawText("Seat Name", { x: 400, y: y + 40, size: 12, font });
        page.drawText("Standing", {
          x: 400,
          y: y + 25,
          size: 10,
          font,
        });

        // QR Code

        // Step 1: Generate QR Code as a Base64 image
        const qrImageBase64 = await QRCode.toDataURL("qrValue");

        // Step 2: Create a new PDF document
        const pdfDoc = await PDFDocument.create();

        // Step 3: Embed the QR Code image into the PDF
        const qrImageBytes = await fetch(qrImageBase64).then((res) =>
          res.arrayBuffer()
        );
        const qrEmbed = await pdfDoc.embedPng(qrImageBytes);

        // Step 4: Draw the QR Code on the PDF page

        page.drawImage(qrEmbed, { x: 400, y: y - 40, width: 60, height: 60 });

        // Cut Line after each ticket
        y -= 20;
        page.drawLine({
          start: { x: 50, y },
          end: { x: 545, y },
          thickness: 1,
          color: black,
        });

        // If running out of space, create new page
        if (y < 150 && i < SeatsDetails.length - 1) {
          const newPage = pdfDoc.addPage([595, 900]);
          y = 850; // Reset Y for new page
        }
      }
    } else if (sessionStorage.getItem("CategoryType") === "virtual")  {
      //Virtual Ticket
      // Draw Invoice Details
      y -= 80;
      page.drawText(
        `Invoice to: ${sessionStorage.getItem(
          "userfirstname"
        )} ${sessionStorage.getItem("userlastname")}`,
        {
          x: 50,
          y,
          size: 12,
          font,
        }
      );
      page.drawText(
        `Invoice ID: ${sessionStorage.getItem("paymentIDstanding")}`,
        {
          x: 300,
          y,
          size: 12,
          font,
        }
      );
      // Table Header
      y -= 40;
      page.drawRectangle({
        x: 50,
        y: y,
        width: 495,
        height: 25,
        color: grey,
      });

      page.drawText("#", { x: 60, y: y + 7, size: 12, font, color: black });
      page.drawText("Event Details", { x: 90, y: y + 7, size: 12, font });
      page.drawText("Type", { x: 250, y: y + 7, size: 12, font });
      page.drawText("Qty", { x: 340, y: y + 7, size: 12, font });
      page.drawText("Unit Price", { x: 390, y: y + 7, size: 12, font });
      page.drawText("Total", { x: 480, y: y + 7, size: 12, font });

      // Table Content
      y -= 30;
      page.drawText("1", { x: 60, y, size: 12, font });
      page.drawText(`${eventData[0]?.EventTitle}`, {
        x: 90,
        y,
        size: 12,
        font,
      });
      page.drawText(eventData[0]?.EventType, { x: 250, y, size: 12, font });
      page.drawText(SeatsDetailsStanding.length.toString(), {
        x: 340,
        y,
        size: 12,
        font,
      });
      page.drawText(
        `${eventData[0]?.sell_currency}  ${Number(selectedVirtualCategory.price)
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        { x: 390, y, size: 12, font }
      );
      page.drawText(
        `${eventData[0]?.sell_currency} ${Number(
          selectedVirtualCategory.price * SeatsDetailsStanding?.length
        )
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        {
          x: 480,
          y,
          size: 12,
          font,
        }
      );

      // Invoice Total
      y -= 40;
      page.drawText(
        `Invoice Total: ${eventData[0]?.sell_currency} ${Number(
          selectedVirtualCategory.price * SeatsDetailsStanding?.length
        )
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        {
          x: 400,
          y,
          size: 14,
          font,
        }
      );
    } else {
      // Draw Invoice Details
      y -= 80;
      page.drawText(
        `Invoice to: ${sessionStorage.getItem(
          "userfirstname"
        )} ${sessionStorage.getItem("userlastname")}`,
        {
          x: 50,
          y,
          size: 12,
          font,
        }
      );
      page.drawText(`Invoice ID: ${sessionStorage.getItem("Paymentid")}`, {
        x: 300,
        y,
        size: 12,
        font,
      });
      // Table Header
      y -= 40;
      page.drawRectangle({
        x: 50,
        y: y,
        width: 495,
        height: 25,
        color: grey,
      });

      page.drawText("#", { x: 60, y: y + 7, size: 12, font, color: black });
      page.drawText("Event Details", { x: 90, y: y + 7, size: 12, font });
      page.drawText("Type", { x: 250, y: y + 7, size: 12, font });
      page.drawText("Qty", { x: 340, y: y + 7, size: 12, font });
      page.drawText("Unit Price", { x: 390, y: y + 7, size: 12, font });
      page.drawText("Total", { x: 480, y: y + 7, size: 12, font });

      // Table Content
      y -= 30;
      page.drawText("1", { x: 60, y, size: 12, font });
      page.drawText(`${eventData[0]?.EventTitle}`, {
        x: 90,
        y,
        size: 12,
        font,
      });
      page.drawText(eventData[0]?.EventType, { x: 250, y, size: 12, font });
      page.drawText(SeatsDetails.length.toString(), {
        x: 340,
        y,
        size: 12,
        font,
      });
      page.drawText(
        `${eventData[0]?.sell_currency}  ${Number(
          SeatsDetails[0]?.seatD?.seat_price
        )
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        { x: 390, y, size: 12, font }
      );
      page.drawText(
        `${eventData[0]?.sell_currency} ${Number(
          SeatsDetails[0]?.seatD?.seat_price * SeatsDetails?.length
        )
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        {
          x: 480,
          y,
          size: 12,
          font,
        }
      );

      // Invoice Total
      y -= 40;
      page.drawText(
        `Invoice Total: ${eventData[0]?.sell_currency} ${Number(
          SeatsDetails[0]?.seatD?.seat_price * SeatsDetails?.length
        )
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`,
        {
          x: 400,
          y,
          size: 14,
          font,
        }
      );
      // Draw Cut Line
      y -= 20;
      page.drawLine({
        start: { x: 50, y },
        end: { x: 545, y },
        thickness: 1,
        color: black,
      });
      // Ticket dimensions (adjust if needed)
      const ticketWidth = 500;
      const ticketHeight = 150;
      const greyBoxWidth = ticketWidth / 2; // Half the width
      const borderThickness = 1; // Thickness of the border

      const startX = 50; // Adjust as needed
      const startY = 350; // Adjust as needed
      // Map Over Tickets
      for (let i = 0; i < SeatsDetails.length; i++) {
        const ticket = SeatsDetails[i];
        console.log("ticket", ticket);
        y -= 120;
        // STEP 1: Draw the left grey section (only background)
        page.drawRectangle({
          x: 60,
          y: y-50,
          width: ticketWidth / 2, // Half of the ticket width
          height: ticketHeight,
          color: grey,
          opacity: 1, // Ensure solid background
        });

        // STEP 2: Draw the border LAST (so it doesn't overlap table)
        page.drawRectangle({
          x: 60,
          y: y - 50,
          width: ticketWidth,
          height: ticketHeight,
          borderColor: black,
          borderWidth: borderThickness,
          color: undefined, // Ensures no extra background fill
        });

        // Event Image (if needed).
        if (eventData[0].EventImagePath !== "path") {
          page.drawImage(eventData[0].EventImagePath, {
            x: 60,
            y: y - 50,
            width: 50,
            height: 50,
          });
        } else {
          page.drawImage(pngImage, {
            x: 50,
            y: 20,
            width: 100,
            height: 50,
          });
        }

        // Event Details
        page.drawText(eventData[0].EventTitle, {
          x: 120,
          y: y + 40,
          size: 12,
          font,
        });
        page.drawText(
          `${moment(eventData[0].StartDate).format("DD MMM YYYY, hh:mm A")}`,
          { x: 120, y: y + 25, size: 10, font }
        );
        page.drawText(
          `Total: ${eventData[0]?.sell_currency} ${ticket.seatD.seat_price}`,
          {
            x: 120,
            y: y + 10,
            size: 10,
            font,
          }
        );

        // Seat Details
        page.drawText("Seat Name", { x: 400, y: y + 40, size: 12, font });
        page.drawText(ticket?.seatD.seat_name, {
          x: 400,
          y: y + 25,
          size: 10,
          font,
        });

        // QR Code

        // Step 1: Generate QR Code as a Base64 image
        const qrImageBase64 = await QRCode.toDataURL("qrValue");

        // Step 2: Create a new PDF document
        const pdfDoc = await PDFDocument.create();

        // Step 3: Embed the QR Code image into the PDF
        const qrImageBytes = await fetch(qrImageBase64).then((res) =>
          res.arrayBuffer()
        );
        const qrEmbed = await pdfDoc.embedPng(qrImageBytes);

        // Step 4: Draw the QR Code on the PDF page

        page.drawImage(qrEmbed, { x: 400, y: y - 40, width: 60, height: 60 });

        // Cut Line after each ticket
        y -= 20;
        page.drawLine({
          start: { x: 50, y },
          end: { x: 545, y },
          thickness: 1,
          color: black,
        });

        // If running out of space, create new page
        if (y < 150 && i < SeatsDetails.length - 1) {
          const newPage = pdfDoc.addPage([595, 900]);
          y = 850; // Reset Y for new page
        }
      }
    }
    // Save PDF
    const pdfBytes = await pdfDoc.save();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });

    // 9️⃣ Convert Blob to File
    const pdfFile = new File([blob], "invoice.pdf", {
      type: "application/pdf",
    });

    // 6️⃣ Send PDF via API
    await sendPDF(pdfFile, newArray);
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
}

// Upload PDF to API
async function sendPDF(pdfFile, newArray) {
  try {
    const API_URL = API_DOMAIN + "user/sendticket";
    const emailList = JSON.stringify(newArray);
    const data = new FormData();
    const EveDetail = JSON.parse(sessionStorage.getItem("EveDetail")) || [];

    if (!EveDetail.length) {
      console.error("EveDetail is missing or empty.");
      return;
    }

    console.log("Sending Data:", newArray, emailList, EveDetail);

    let headerConfig = {
      headers: {
        authorization: "bearer " + sessionStorage.getItem("token"),
      },
    };

    // Ensure pdfFile is a valid File object
    // if (!(pdfFile instanceof File)) {
    //   pdfFile = new File([pdfFile], "ticket.pdf", { type: "application/pdf" });
    // }

    data.append("att_file", pdfFile);
    data.append("userdetails", emailList);
    data.append(
      "eventname",
      JSON.stringify(EveDetail[0]?.EventTitle || "Unknown Event")
    );
    data.append(
      "match_date",
      JSON.stringify(moment.utc(EveDetail[0]?.StartDate).format("DD MMM, yyyy"))
    );
    data.append(
      "match_time",
      JSON.stringify(moment.utc(EveDetail[0]?.StartTime).format("h:mmA"))
    );

    const response = await axios.post(API_URL, data, headerConfig);
    console.log("PDF Sent Successfully:", response.data);
  } catch (error) {
    if (error.response?.status === 427) {
      sessionStorage.clear();
      localStorage.clear();
      setTimeout(() => {
        // navigate("/");
      }, 1000);
    } else {
      console.error(
        "Error Sending PDF:",
        error.response?.data?.message || error
      );
      toast.error(error.response?.data?.message || "An error occurred");
    }
  }
}
